/* eslint-disable @typescript-eslint/naming-convention */
export const PURGE_SCHEDULES = "@SCHEDULES/PURGE_SCHEDULES";
export type PURGE_SCHEDULES = typeof PURGE_SCHEDULES;

export const SET_SCHEDULE = "@SCHEDULES/SET_SCHEDULE";
export type SET_SCHEDULE = typeof SET_SCHEDULE;
